// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__3th_E","actions":"Login_actions__dRf3O","button--alt":"Login_button--alt__2ARrK","button":"Login_button__JtEWo"};